import { Link } from "react-router-dom";
import styled from "styled-components";

export const LoadingIconContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const MainWrapper = styled.div`
  padding: ${({ theme }) => theme.resolve("spacing_xl")};
  align-self: stretch;
  border-radius: ${({ theme }) => theme.resolve("radius_md")};
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.resolve("color_border_lighter")};
  background: ${({ theme }) => theme.resolve("color_bg_surface_standard")};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
  width: 100%;

  > div > div > div:first-child {
    border-bottom: none !important;
  }
  > div > div > .accordion-content-wrapper {
    border-bottom: none !important;
    padding-bottom: 0 !important;
  }

  > div > div > div:first-child > div {
    padding-bottom: 0 !important;
  }
`;

export const DataState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.resolve("spacing_2xl")};
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-size: ${({ theme }) => theme.resolve("font_size_md")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_regular")};
  color: ${({ theme }) => theme.resolve("color_text_secondary")};
`;

export const LinkAttr = styled(Link)`
  color: ${({ theme }) => theme.resolve("color_text_secondary")};
  padding: 0;
`;

export const HistoryListItem = styled.li<{
  $removed?: boolean;
  $added?: boolean;
}>`
  color: ${({ theme }) => theme.resolve("color_text_secondary")};
  a,
  span {
    background-color: ${({ theme, $removed, $added }) =>
      $removed
        ? theme.resolve("color_bg_surface_error_diff")
        : $added
        ? theme.resolve("color_bg_surface_success_diff")
        : "transparent"};
    padding: ${({ theme }) => theme.resolve("spacing_xs")}
      ${({ theme }) => theme.resolve("spacing_sm")};
    border-radius: ${({ theme }) => theme.resolve("radius_xs")};
    font-size: ${({ theme }) => theme.resolve("font_size_md")};
    font-weight: ${({ theme }) => theme.resolve("font_weight_regular")};
    color: ${({ theme }) => theme.resolve("color_text_primary")};
    line-height: ${({ theme }) => theme.resolve("line_height_md")};
  }
`;

export const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
  width: 100%;
  margin-top: ${({ theme }) => theme.resolve("spacing_xs")};
`;

export const DateTime = styled.span`
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-size: ${({ theme }) => theme.resolve("font_size_sm")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_regular")};
  color: ${({ theme }) => theme.resolve("color_text_tertiary")};
  line-height: ${({ theme }) => theme.resolve("line_height_sm")};
  white-space: nowrap;
`;

export const ModifiedText = styled.span`
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-size: ${({ theme }) => theme.resolve("font_size_md")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_regular")};
  color: ${({ theme }) => theme.resolve("color_text_primary")};
  line-height: ${({ theme }) => theme.resolve("line_height_md")};

  b {
    font-weight: ${({ theme }) => theme.resolve("font_weight_semibold")};
  }
`;

export const EmphasisText = styled.span`
  color: ${({ theme }) => theme.resolve("color_text_primary")};
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-size: ${({ theme }) => theme.resolve("font_size_md")};
  font-style: normal;
  font-weight: ${({ theme }) => theme.resolve("font_weight_semibold")};
  line-height: ${({ theme }) => theme.resolve("line_height_md")};
`;

export const GroupTitle = styled.div`
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-size: ${({ theme }) => theme.resolve("font_size_base")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_regular")};
  color: ${({ theme }) => theme.resolve("color_text_primary")};
  padding: ${({ theme }) => theme.resolve("spacing_md")};

  b {
    font-weight: ${({ theme }) => theme.resolve("font_weight_semibold")};
  }
`;

export const ChangeSection = styled.div`
  padding: ${({ theme }) => theme.resolve("spacing_md")};
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  position: relative;
  overflow: visible;
`;

export const SubItemContainer = styled.div`
  padding-left: ${({ theme }) => theme.resolve("spacing_md")};
  margin-top: 0;
`;

export const SubItemHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.resolve("spacing_sm")};
  padding: ${({ theme }) => theme.resolve("spacing_md")};
  cursor: pointer;
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
`;

export const CaretWrapper = styled.div<{ isExpanded: boolean }>`
  transform: ${({ isExpanded }) =>
    isExpanded ? "rotate(0deg)" : "rotate(-90deg)"};
  transition: transform 0.2s ease-out;
  display: flex;
  align-items: center;
`;

export const SubItemContent = styled.div`
  position: relative;
  overflow: visible;
`;

export const SubItemCard = styled.div`
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.resolve("color_border_lighter")};
  border-radius: ${({ theme }) => theme.resolve("radius_sm")};
  background-color: ${({ theme }) =>
    theme.resolve("color_bg_surface_standard")};
  padding: ${({ theme }) => theme.resolve("spacing_sm")}
    ${({ theme }) => theme.resolve("spacing_md")};
  margin: ${({ theme }) => theme.resolve("spacing_lg")} 0;
  overflow: hidden;
`;

export const ChangeContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.resolve("spacing_xl")};
  width: 100%;
  min-height: 36px;

  /* Ensure equal widths for columns */
  > div {
    flex: 1 1 0;
    min-width: 0;
  }
`;

export const StateColumn = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
`;

export const StateLabel = styled.div`
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-size: ${({ theme }) => theme.resolve("font_size_sm")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_medium")};
  color: ${({ theme }) => theme.resolve("color_text_tertiary")};
  line-height: ${({ theme }) => theme.resolve("line_height_sm")};
  text-align: left;
`;

export const StateValue = styled.div`
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-size: ${({ theme }) => theme.resolve("font_size_md")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_regular")};
  color: ${({ theme }) => theme.resolve("color_text_primary")};
  line-height: ${({ theme }) => theme.resolve("line_height_md")};
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
`;

export const DiffText = styled.span<{
  added?: boolean;
  removed?: boolean;
  useTextColor?: boolean;
}>`
  display: inline-block;
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-size: ${({ theme }) => theme.resolve("font_size_md")};
  background-color: ${({ theme, added, removed, useTextColor }) =>
    useTextColor
      ? "transparent"
      : added
      ? theme.resolve("color_bg_surface_success_diff")
      : removed
      ? theme.resolve("color_bg_surface_error_diff")
      : "transparent"};
  color: ${({ theme, added, removed, useTextColor }) =>
    useTextColor
      ? added
        ? theme.resolve("color_text_success")
        : removed
        ? theme.resolve("color_text_error")
        : theme.resolve("color_text_secondary")
      : theme.resolve("color_text_secondary")};
  border-radius: ${({ theme }) => theme.resolve("radius_xxs")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_regular")};
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
  max-width: 100%;
`;

export const FixedCardPreview = styled.div`
  z-index: 500;
  width: 360px;
  pointer-events: none;
  background-color: ${({ theme }) =>
    theme.resolve("color_bg_surface_standard")};
  border-radius: ${({ theme }) => theme.resolve("radius_md")};
  padding: ${({ theme }) => theme.resolve("spacing_sm")};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);

  & > div {
    pointer-events: auto;
  }

  button {
    display: none !important;
  }

  a,
  span {
    background-color: transparent !important;
    padding: 0 !important;
    border-radius: 0 !important;
  }
`;

export const ImagePreview = styled.img`
  max-width: 100px;
  max-height: 100px;
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.resolve("color_border_lighter")};
`;

export const ImageInfo = styled.div`
  margin-top: ${({ theme }) => theme.resolve("spacing_md")};
  font-size: ${({ theme }) => theme.resolve("font_size_xs")};
  color: ${({ theme }) => theme.resolve("color_text_secondary")};
`;

export const ChangeSeparator = styled.div`
  border-top: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.resolve("color_border_lighter")};
  margin: ${({ theme }) => theme.resolve("spacing_sm")} 0;
  width: 100%;
`;

export const ToggleContainer = styled.div`
  div {
    align-items: start !important;
  }
`;

export const AssetNameWrapper = styled.div`
  width: 100%;
  min-width: 0;

  > div {
    flex-wrap: nowrap !important;
    align-items: flex-start !important;
    min-width: 0;
    width: 100%;

    > div:first-child {
      flex-shrink: 0;
      padding-top: ${({ theme }) => theme.resolve("spacing_xxs")};
    }

    > div:last-child {
      flex: 1;
      min-width: 0;
      width: auto;

      span,
      div {
        white-space: normal !important;
        overflow: visible !important;
        text-overflow: clip !important;
        word-break: break-word;
        overflow-wrap: anywhere;
        max-width: 100%;
      }
    }
  }
`;

export const HistoryNoImagePlaceholder = styled.div`
  width: 100px;
  height: 100px;
  background-color: ${({ theme }) => theme.resolve("color_bg_surface_subtle")};
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.resolve("spacing_xs")};
`;

export const HistoryNoImageIcon = styled.div`
  font-size: ${({ theme }) => theme.resolve("font_size_xl")};
  color: ${({ theme }) => theme.resolve("color_text_placeholder")};
`;

export const HistoryNoImageText = styled.div`
  font-family: ${({ theme }) => theme.resolve("font_family_primary")};
  font-size: ${({ theme }) => theme.resolve("font_size_sm")};
  font-weight: ${({ theme }) => theme.resolve("font_weight_medium")};
  color: ${({ theme }) => theme.resolve("color_text_placeholder")};
  line-height: ${({ theme }) => theme.resolve("line_height_sm")};
`;
